import { FormField, Select } from '@/shared/components';
import { clockFromMinutes, SLOT_MINUTES } from '../resourceModel';
import { slotRange } from './resourceBlockModel';

/** „Von“ und „Bis“ im Sperren-Blatt – nur halbe Stunden im Fenster der gewählten Ressource. */
export function ResourceTimeFields({
  hours,
  startMinute,
  endMinute,
  onStart,
  onEnd,
}: {
  hours: { opensAtMinute: number; closesAtMinute: number } | null;
  startMinute: number;
  endMinute: number;
  onStart: (minute: number) => void;
  onEnd: (minute: number) => void;
}) {
  const starts = hours ? slotRange(hours.opensAtMinute, hours.closesAtMinute - SLOT_MINUTES) : [];
  const ends = hours ? slotRange(startMinute + SLOT_MINUTES, hours.closesAtMinute) : [];
  return (
    <div className="grid grid-cols-2 gap-4">
      <FormField label="Von" required>
        <Select
          value={startMinute}
          disabled={!hours}
          onChange={(event) => onStart(Number(event.target.value))}
        >
          {starts.map((minute) => (
            <option key={minute} value={minute}>
              {clockFromMinutes(minute)}
            </option>
          ))}
        </Select>
      </FormField>
      <FormField label="Bis" required>
        <Select
          value={endMinute}
          disabled={!hours}
          onChange={(event) => onEnd(Number(event.target.value))}
        >
          {ends.map((minute) => (
            <option key={minute} value={minute}>
              {clockFromMinutes(minute)}
            </option>
          ))}
        </Select>
      </FormField>
    </div>
  );
}
